import React from 'react';
import { TestToolsTab } from './DevTools/TestToolsTab';
import { uiActionBridge } from '../framework/uiActionBridge';

/**
 * Simulation & Tests — scenario runner + perf benchmark (TestToolsTab).
 *
 * Engine window (HUD fold, 2026-06-12): the registry provides the ToolWindow
 * chrome; this is the propless Content body. Actions route through
 * uiActionBridge → ActionDispatcher (the engine-mounted-content pattern).
 * Distinct surface from `simulationPanel` (SimulationControlPanel bot/chaos
 * sim) — the old DEV-BAR 🧪 button used to open BOTH via double-dispatch.
 */
export const SimulationToolsContent: React.FC = () => (
  <div style={{ overflowY: 'auto', height: '100%' }}>
    <TestToolsTab onAction={(action, data) => uiActionBridge.dispatch(action, data)} />
  </div>
);
